
<template>
    <div class="page-container">
        <header class="login-header" :class="className">
            <img :src="logo" class="login-header-logo"/><span @click='goAdmin()' class="app-name">{{name}}</span>
        </header>
        <main class="page-content" :class="bgClassName">
            <div class="login-container">
                <div class="login-content u-mt16">
                    <div class="login-tabs">
                        <a class="tab-item" :class="{'tab-item--selected': currentView == MOBILE_LOGIN}" href="javascript:;" @click="currentView = MOBILE_LOGIN">快捷登录</a>
                        <a class="tab-item" :class="{'tab-item--selected': currentView == PASSWORD_LOGIN}" href="javascript:;" @click="currentView = PASSWORD_LOGIN">密码登录</a>
                    </div>
                    <div class="login-form">
                        <mobile-login v-show="currentView == MOBILE_LOGIN" @on-success="onSuccessLogin"></mobile-login>
                        <password-login v-show="currentView == PASSWORD_LOGIN" @on-success="onSuccessLogin" @on-failure="onFailureLogin"></password-login>
                    </div>
                    <div class="other-login-container">
                        <a class="other-login" @click="handleOtherLogin('lianjia')">
                            <img src="/static/images/lianjia-login.svg" alt="贝壳"> 贝壳登录
                        </a>
                    </div>
                    <form :action="redirectForm.callbackUrl" style="display: none" id="redirectForm" method="post">
                        <input type="hidden" name="authToken" v-model="redirectForm.authToken">
                        <input type="hidden" name="site" v-model="redirectForm.site">
                        <input type="hidden" name="zd_tgt" v-model="redirectForm.zd_tgt">
                    </form>
                </div>
            </div>
        </main>
        <div class="other-login-dialog" v-if="showEmpNoLogin" @click="showEmpNoLogin=false">
            <div class="other-login-dialog-content" @click.stop>
                <empno-login @on-success="onSuccessLogin" @on-failure="onFailureLogin" @on-close="showEmpNoLogin=false"></empno-login>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorCodeMixin from './mixin/ErrorCodeMixin.vue'
    import MobileLogin from './component/MobileLogin.vue'
    import EmpNoLogin from './component/EmpNoLogin.vue'
    import PasswordLogin from './component/PasswordLogin.vue'
    import siteConfig from '../config/site'
    const { name, logo, className, bgClassName } = siteConfig[appconfig.groupId]

    export default {
        mixins: [ErrorCodeMixin],
        data: function() {
            return {
                MOBILE_LOGIN: 'mobile-login',
                PASSWORD_LOGIN: 'password-login',
                currentView: 'mobile-login',
                showEmpNoLogin: false,
                redirectForm: {
                    callbackUrl: '',
                    ticket: '',
                    ref: '',
                    zd_tgt:''
                },
                name, logo, className, bgClassName
            }
        },
        methods: {
            onSuccessLogin: function(data) {
                this.redirectForm.callbackUrl = data.data.callbackUrl
                this.redirectForm.authToken = data.data.authToken
                this.redirectForm.site = data.data.site
                this.redirectForm.zd_tgt  = data.data.zd_tgt
                setTimeout(function() {
                    document.getElementById('redirectForm').submit()
                })
            },
            onFailureLogin: function() {
                this.showEmpNoLogin = false;
                this.currentView = this.MOBILE_LOGIN;
            },
            handleOtherLogin: function(company){
                this.showEmpNoLogin = true;
            },
            goAdmin: function () {
               if (this.name === '贝壳经纪学堂后台管理系统') {
                 let host = window.location.host;
                 if(host.indexOf('test') > -1 ) {
                   window.location.href = 'http://zhidao.shtest.ke.com';
                 }
                 if(host.indexOf('shoff') > -1 || host.indexOf('off') > -1 ) {
                   window.location.href = 'https://zhidao.shoff.ke.com';
                 }

                   if(host === 'zlogin.ke.com') {
                       window.location.href = 'https://zhidao.ke.com';
                   }
              }
            }
        },
        components: {
            'mobile-login': MobileLogin,
            'empno-login': EmpNoLogin,
            'password-login': PasswordLogin
        }
    }
</script>



// WEBPACK FOOTER //
// App.vue?242ece73